export default __webpack_public_path__ + "static/media/move_down.e477f2be.svg";